import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { dataServices } from "../data/servicesData";
export default function Header(params) {
  let [isArrowRightContacts, setIsArrowRightContacts] = useState(false);
  let [isArrowRightService, setIsArrowRightService] = useState(false);
  let [isArrowRightCenter, setIsArrowRightCenter] = useState(false);
  let [isArrowRightWork, setIsArrowRightWork] = useState(false);
  let [isOpenSearchMenu, setIsOpenSearchMenu] = useState(false);
  let refBurgerMenu = useRef(null);
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  // куки
  useEffect(() => {
    const getCookie = (name) => {
      const cookieName = name + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
          return cookie.substring(cookieName.length, cookie.length);
        }
      }
      return "";
    };
    
    if (!getCookie('cookie_consent')) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    const setCookie = (name, value, days) => {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    };
    setCookie('cookie_consent', 'accepted', 365);
    setShowCookieBanner(false);
  };

  function closeMenu() {
    refBurgerMenu.current.click();
  }

  function closeMenuSearch() {
    setIsOpenSearchMenu(false);
  }

  function openMenuSearch() {
    setIsOpenSearchMenu(true);
  }

  return (
    <header>
      <div className="container">
        <div className="header_menu">
          <div className="header_logo">
            <Link to="/">
              <img className="logo_1"
                src={process.env.PUBLIC_URL + "/img/header/logo_1.png"}
                alt="Логотип"
              />
              <img className="logo_2"
                src={process.env.PUBLIC_URL + "/img/header/logo_2.png"}
                alt="Логотип"
              />
            </Link>
          </div>
          <div className="header_menu_inform">
            <div className="menu_inform_top">
              <marquee scrollamount="5" className="running_line">
                <p>
                  Министерством юстиции Российской Федерации выдано
                  Свидетельство о регистрации №7314050210 от 23.01.2014
                  Автономной Некоммерческой Организации
                </p>
              </marquee>
            </div>
            <nav className="menu_inform_bottom">
              <ul>
                <li>
                  <div
                    className="header_menu_items is_menu submenu"
                    // href="#"
                    onMouseEnter={() => {
                      setIsArrowRightContacts(true);
                    }}
                    onMouseLeave={() => {
                      setIsArrowRightContacts(false);
                    }}
                  >
                    <span>
                      <span className="about_company">О компании</span>
                    </span>
                    {isArrowRightContacts && (
                      <img
                        className=""
                        src={
                          process.env.PUBLIC_URL + "/img/header/arrow_right.png"
                        }
                        alt="вправо"
                      />
                    )}
                    {!isArrowRightContacts && (
                      <img
                        className=""
                        src={
                          process.env.PUBLIC_URL + "/img/header/arrow_down.png"
                        }
                        alt="вниз"
                      />
                    )}
                    <div className="submenu_body submenu_body_2">
                      <div className="submenu_body_block">
                        <Link to="/command">
                          <p className="submenu_body_title submenu_body_title_item1">
                            Команда
                          </p>
                        </Link>
                      </div>
                      <div className="submenu_body_block">
                        <Link to="/equipment">
                          <p className="submenu_body_title submenu_body_title_item1">
                            Оборудование
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div
                    className="header_menu_items is_menu submenu"
                    // href="#"
                    onMouseEnter={() => {
                      setIsArrowRightService(true);
                    }}
                    onMouseLeave={() => {
                      setIsArrowRightService(false);
                    }}
                  >
                    <span>
                      <span>Услуги</span>
                    </span>
                    {isArrowRightService && (
                      <img
                        className=""
                        src={
                          process.env.PUBLIC_URL + "/img/header/arrow_right.png"
                        }
                        alt="вправо"
                      />
                    )}
                    {!isArrowRightService && (
                      <img
                        className=""
                        src={
                          process.env.PUBLIC_URL + "/img/header/arrow_down.png"
                        }
                        alt="вниз"
                      />
                    )}

                    <div className="submenu_body">
                      {dataServices.map((e, i) => (
                        <div key={i} className="submenu_body_block">
                          <p className="submenu_body_title">{e.groupingMenu}</p>
                          <div className="submenu_body_item">
                            {e.subMenuItems.map((el, index) => (
                              <Link
                                key={index + "menmin"}
                                to={`/services/${e.menuId}/${el.subMenuId}`}
                              >
                                <p>&bull; {el.subMenuTitle}</p>
                              </Link>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
                <li>
                  <Link to="/news" className="header_menu_items is_menu">
                    <span>Пресс-центр</span>
                  </Link>
                </li>
                <li>
                  <Link to="/career" className="header_menu_items is_menu">
                    <span>Карьера</span>
                  </Link>
                </li>
                <li>
                  <Link to="/contacts" className="header_menu_items is_menu">
                    <span>Контакты</span>
                  </Link>
                </li>
                <li className="header_link">
                  <a href="https://vk.com/rusnekc" className="header_link_item">
                    <svg
                      width="16"
                      height="10"
                      viewBox="0 0 16 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M15.7632 8.62805C15.7451 8.58688 15.7281 8.55274 15.7124 8.52538C15.4521 8.03247 14.9548 7.42745 14.2207 6.71015L14.2052 6.69373L14.1974 6.68567L14.1896 6.67742H14.1817C13.8485 6.34341 13.6375 6.11883 13.5492 6.00385C13.3875 5.78482 13.3513 5.56311 13.4397 5.33847C13.5021 5.16875 13.7366 4.81032 14.1426 4.26269C14.3561 3.97246 14.5252 3.73986 14.6501 3.56461C15.551 2.30521 15.9415 1.50044 15.8217 1.14997L15.7751 1.06808C15.7439 1.01877 15.6632 0.973663 15.5332 0.932527C15.4029 0.891477 15.2363 0.884688 15.0332 0.912045L12.784 0.928385C12.7476 0.914807 12.6955 0.916072 12.6278 0.932527C12.5601 0.948981 12.5262 0.957238 12.5262 0.957238L12.487 0.977806L12.456 1.00252C12.4299 1.01886 12.4013 1.04759 12.37 1.08867C12.3389 1.12961 12.3129 1.17765 12.2921 1.23239C12.0472 1.89491 11.7688 2.51089 11.4564 3.0803C11.2637 3.41983 11.0868 3.71408 10.9252 3.96323C10.7638 4.21229 10.6285 4.39579 10.5192 4.51342C10.4098 4.63116 10.311 4.72549 10.2224 4.79674C10.1338 4.86803 10.0662 4.89814 10.0194 4.88713C9.9725 4.87611 9.92832 4.86518 9.8865 4.85425C9.81365 4.80494 9.75506 4.73789 9.71088 4.65302C9.66652 4.56816 9.63664 4.46135 9.62103 4.33268C9.60549 4.20392 9.5963 4.09317 9.59367 4.00005C9.59124 3.90705 9.59236 3.7755 9.59764 3.60578C9.60305 3.43597 9.60549 3.32107 9.60549 3.26084C9.60549 3.05274 9.60935 2.82689 9.61709 2.58324C9.62496 2.33959 9.63134 2.14653 9.63667 2.00431C9.64198 1.86195 9.64444 1.71133 9.64444 1.55253C9.64444 1.39374 9.63525 1.26921 9.61709 1.17883C9.59914 1.08856 9.5716 1.00093 9.5353 0.915986C9.49878 0.831125 9.44533 0.76548 9.37519 0.718878C9.30492 0.672333 9.21755 0.635397 9.11357 0.607954C8.8376 0.54228 8.48618 0.506753 8.05915 0.50123C7.09078 0.490298 6.46855 0.556059 6.1926 0.698424C6.08326 0.758575 5.98432 0.840761 5.89586 0.944724C5.80211 1.06523 5.78904 1.13099 5.85671 1.1418C6.16915 1.19102 6.39034 1.30877 6.52052 1.49491L6.56743 1.59355C6.60392 1.66472 6.64036 1.79072 6.67682 1.97137C6.71323 2.15203 6.73673 2.35187 6.74707 2.57078C6.77306 2.97055 6.77306 3.31276 6.74707 3.59744C6.721 3.88222 6.69638 4.10393 6.67288 4.26272C6.64939 4.42151 6.61426 4.55018 6.56743 4.64871C6.52052 4.74726 6.48931 4.8075 6.47366 4.82936C6.45804 4.85123 6.44502 4.86501 6.43468 4.87041C6.36701 4.89768 6.29663 4.91158 6.22378 4.91158C6.15083 4.91158 6.06236 4.8732 5.95825 4.79651C5.85417 4.71982 5.74615 4.61448 5.63419 4.48031C5.52222 4.34611 5.39596 4.15858 5.25533 3.91769C5.11481 3.6768 4.96901 3.3921 4.81801 3.06358L4.69309 2.82534C4.61499 2.67207 4.50831 2.4489 4.37293 2.15603C4.23747 1.86304 4.11774 1.57963 4.01366 1.30586C3.97205 1.19088 3.90955 1.10334 3.82626 1.04311L3.78717 1.0184C3.76118 0.996533 3.71946 0.973318 3.66224 0.948579C3.60493 0.923868 3.54514 0.906148 3.4826 0.895245L1.3427 0.911585C1.12403 0.911585 0.975661 0.963681 0.897537 1.06773L0.866271 1.11695C0.850651 1.14436 0.842773 1.18815 0.842773 1.24841C0.842773 1.30865 0.858393 1.38258 0.889659 1.47012C1.20205 2.24221 1.54176 2.98684 1.9088 3.7041C2.27584 4.42137 2.59479 4.99914 2.86546 5.43691C3.13619 5.875 3.41214 6.28846 3.69331 6.6771C3.97449 7.06588 4.16061 7.31503 4.25167 7.42448C4.34284 7.53414 4.41446 7.61613 4.46651 7.67087L4.66179 7.86795C4.78675 7.99938 4.97024 8.15679 5.21235 8.34018C5.45452 8.52368 5.72262 8.70434 6.01679 8.88243C6.31101 9.06024 6.6533 9.20534 7.04384 9.31756C7.43432 9.42989 7.81438 9.47497 8.18407 9.45322H9.08223C9.26438 9.43668 9.40238 9.37644 9.49618 9.27248L9.52725 9.23131C9.54815 9.19864 9.56771 9.14786 9.58577 9.07954C9.60404 9.01111 9.61312 8.93571 9.61312 8.85369C9.60779 8.6183 9.62483 8.40614 9.66378 8.21726C9.7027 8.02844 9.74707 7.88607 9.79669 7.79019C9.84629 7.6944 9.90226 7.61357 9.96454 7.54804C10.027 7.48236 10.0714 7.44258 10.0975 7.42889C10.1235 7.41511 10.1442 7.40576 10.1598 7.40015C10.2848 7.35636 10.4318 7.39877 10.6012 7.52755C10.7704 7.65623 10.9292 7.81511 11.0776 8.00393C11.226 8.19293 11.4043 8.40496 11.6126 8.64036C11.8209 8.87584 12.0031 9.05089 12.1592 9.16604L12.3154 9.2646C12.4196 9.33036 12.555 9.39059 12.7217 9.44534C12.888 9.50005 13.0338 9.51374 13.1589 9.48639L15.1581 9.45359C15.3559 9.45359 15.5098 9.41916 15.6189 9.35084C15.7283 9.2824 15.7932 9.20701 15.8142 9.12499C15.8351 9.04289 15.8362 8.94975 15.8181 8.84561C15.7996 8.74173 15.7814 8.6691 15.7632 8.62805Z" />
                    </svg>
                  </a>
                  <a href="https://t.me/ul_nekc" className="header_link_item">
                    <svg
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M13.655 1.12459C13.7613 0.446476 13.1081 -0.0887603 12.4972 0.175966L0.330457 5.44843C-0.107608 5.63827 -0.0755628 6.29325 0.378776 6.43603L2.88783 7.22469C3.36676 7.37522 3.88526 7.29735 4.30346 7.0122L9.96037 3.15476C10.131 3.03841 10.3169 3.27784 10.1711 3.42609L6.09917 7.56978C5.70417 7.97177 5.78256 8.65293 6.25773 8.94699L10.8167 11.7688C11.3281 12.0852 11.9859 11.7673 12.0815 11.1574L13.655 1.12459Z" />
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="header_call">
            <div className="header_number">
              <a href="tel:+79372757545">8 (937) 275 75 45</a>
            </div>
            <div
              className="header_inscription"
              onClick={() => {
                params.setIsOpenPopUp(true);
              }}
            >
              Перезвоним через 30 сек.
            </div>
          </div>
        </div>
        <div className="header_menu_adaptiv">
          <div className="header_adaptiv_burger" style={{ zIndex: "10001" }}>
            <input
              type="checkbox"
              id="burger-checkbox"
              className="burger-checkbox"
              ref={refBurgerMenu}
            />
            <label htmlFor="burger-checkbox" className="burger"></label>
          </div>
          <div className="header_adaptiv_logo">
            <Link to="/">
              <img className="logo_1"
                src={process.env.PUBLIC_URL + "/img/header/logo_1.png"}
                alt="Логотип"
              />
              <img className="logo_2"
                src={process.env.PUBLIC_URL + "/img/header/logo_2.png"}
                alt="Логотип"
              />
            </Link>
          </div>
          <div className={`header_adaptiv_search ${isOpenSearchMenu ? "" : "close-hover"}`} style={{ zIndex: "10001" }}>
            <img
              src={process.env.PUBLIC_URL + "/img/header/lupa.png"}
              alt="Поиск"
              onTouchEnd={() => {openMenuSearch()}} onClick={() => {openMenuSearch()}}
            />
            {/*<input type="checkbox" id="burger-checkbox" className="burger-checkbox"/>*/}{" "}
            {/* как в бургере */}
            <div className="search_top search-container">
              {/* <input type="text" name="text" placeholder="Пожарная экспертиза"/> */}
              <div
                style={{
                  width: "100%",
                  background: "white",
                  padding: "8px 10px 8px 30px",
                  marginTop: "0",
                }}
                className="search_menu"
              >
                {dataServices.map((e, i) => (
                  <details
                    key={i}
                    className="burger_details"
                    name="search_menu_body"
                  >
                    <summary>
                      <div>{e.groupingMenu}</div>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/img/header/arrow_right_burger.png"
                        }
                        alt=""
                      />
                    </summary>
                    <div>
                      <ul>
                        {e.subMenuItems.map((el, index) => (
                          <li key={index + "menmin"} onClick={() => {closeMenuSearch()}}>
                            <Link to={`/services/${e.menuId}/${el.subMenuId}`}>
                              <p>&bull; {el.subMenuTitle}</p>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
          <div className="menu">
            <div>
              <details className="burger_details">
                <summary>
                  <div>О компании</div>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/header/arrow_right_burger.png"
                    }
                    alt=""
                  />
                </summary>
                <div>
                  <ul>
                    <li>
                      <Link to="/command" onClick={() => {closeMenu()}}>
                        <p className="submenu_body_title">Команда</p>
                      </Link>
                    </li>
                    <li>
                      <Link to="/equipment" onClick={() => {closeMenu()}}>
                        <p className="submenu_body_title">Оборудование</p>
                      </Link>
                    </li>
                  </ul>
                </div>
              </details>
              <details className="burger_details">
                <summary>
                  <div>Услуги</div>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/img/header/arrow_right_burger.png"
                    }
                    alt=""
                  />
                </summary>
                <div>
                  <ul>
                    {dataServices.map((e, i) => (
                      <li key={i}>
                        <details
                          
                          className="burger_details_inner"
                          name="menu_burger_inner"
                        >
                          <summary>{e.groupingMenu}</summary>
                          <div>
                            <ul>
                              {e.subMenuItems.map((el, index) => (
                                <li key={index + "menmin"}>
                                  <Link
                                    to={`/services/${e.menuId}/${el.subMenuId}`}
                                    onClick={() => {closeMenu()}}
                                  >
                                    <p>&bull; {el.subMenuTitle}</p>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </details>
                      </li>
                    ))}
                  </ul>
                </div>
              </details>
              <details className="burger_details">
                <summary>
                  <div>
                    <Link to="/news" onClick={() => {closeMenu()}}>Пресс-центр</Link>
                  </div>
                </summary>
              </details>
              <details className="burger_details">
                <summary>
                  <div>
                    <Link to="/career" onClick={() => {closeMenu()}}>Карьера</Link>
                  </div>
                </summary>
              </details>
              <details className="burger_details">
                <summary>
                  <div>
                    <Link to="/contacts" onClick={() => {closeMenu()}}>Контакты</Link>
                  </div>
                </summary>
              </details>
            </div>
            <div className="menu_contacts_container">
              <div>
                <div>
                  <a href="tel:89372757545" className="header_burger_phone">
                    8 (937) 275 75 45
                  </a>
                </div>
                <div className="menu_images">
                  <a href="https://t.me/ul_nekc" style={{marginRight: "5px"}} className="menu_image_container">
                    <img src="/img/header/tg_menu_adaptive.png" alt="" />
                  </a>
                  <a href="https://vk.com/rusnekc" className="menu_image_container">
                    <img src="/img/header/vk_menu_adaptive.png" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <marquee className="running_line_2">
        <p>
          Министерством юстиции Российской Федерации выдано Свидетельство о
          регистрации №7314050210 от 23.01.2014 Автономной Некоммерческой
          Организации
        </p>
      </marquee>
      {/* куки-баннер */}
      {showCookieBanner && (
        <div className="cookie-consent">
          <p className="fourth_description description">
            Этот сайт использует cookie для улучшения пользовательского опыта. 
            Продолжая использовать сайт, вы соглашаетесь с этим.
          </p>
          <button onClick={acceptCookies} className="blue_button button">
            Принять
          </button>
        </div>
      )}
    </header>
  );
}
